// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___w2N9","content":"styles_content__Y3qYp"};